import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { useAuth } from "../../../AuthProvider";

const baseUrl=process.env.REACT_APP_API_BASE_URL
const StudentBranchTransferList = () => {
  const navigate = useNavigate();
  const {oId}=useAuth();
  // const [searchQuery, setSearchQuery] = useState("");
  // const [filteredData, setFilteredData] = useState([]);
  // const [loading, setLoading] = useState(true);
  // const [selectedClass, setSelectedClass] = useState("");
  // const [selectedSection, setSelectedSection] = useState("");

const [formData, setFormData] = useState({});
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [originalData, setOriginalData] = useState([]); // Original API data
    const [loading, setLoading] = useState(false); //kept true when ever adding api
      const [selectedClass, setSelectedClass] = useState(1);
      const [selectedSection, setSelectedSection] = useState("SECTION-A"); // Default to SECTION-A
    

  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await fetch(
  //         `${baseUrl}/api/studentTransfer/getAllFilterTc/${oId}?romanNumberClass=${toRoman(selectedClass)}&sections=${selectedSection}`);
  //       const data = await response.json();
  //       setOriginalData(data);
  //       setFilteredData(data); // Ensure data is an array
  //     } catch (error) {
  //       console.error("Error fetching data: ", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  // useEffect(() => {
  //   fetchData();
  // }, [selectedClass, selectedSection]); // Re-fetch data when selected class or section changes

  useEffect(() => {
    if (!searchQuery) {
      setFilteredData(originalData); // Reset to original data if search query is empty
     
      return;
    }
  
    const result = originalData.filter((student) => {
      const searchTerm = searchQuery.toLowerCase();
      return (
        String(student.admissionNumber).toLowerCase().includes(searchTerm) || // Add search by admission number
        String(student.surName).toLowerCase().includes(searchTerm) ||
        String(student.firstName).toLowerCase().includes(searchTerm) ||
        String(student.lastName).toLowerCase().includes(searchTerm) ||
        String(student.primaryContact).includes(searchTerm)
      );
    });
  
    setFilteredData(result);
  }, [searchQuery, originalData]);


    // Convert number to Roman numerals
const toRoman = (num) => {
  const romanNumerals = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X"];
  return romanNumerals[num - 1] || num;
};

const romanClassMap = {
  "NURSERY": "LKG",
  "LKG": "UKG",
  "UKG": "I",
  "I": "II",
  "II": "III",
  "III": "IV",
  "IV": "V",
  "V": "VI",
  "VI": "VII",
  "VII": "VIII",
  "VIII": "IX",
  "IX": "X",
};

// Automatically update 'toClass' when 'fromClass' is set
useEffect(() => {
  if (formData.romanNumberClass) {
    setFormData((prev) => ({
      ...prev,
      toClass: romanClassMap[prev.romanNumberClass] || ""
    }));
  }
}, [formData.romanNumberClass]);




  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await fetch(`${baseUrl}/api/studentTransfer/getAll/${oId}`);
  //       const data = await response.json();
        
  //       // Ensure data is an array before setting it
  //       if (Array.isArray(data)) {
  //         setFilteredData(data);
  //       } else {
  //         console.error("API did not return an array. Response:", data);
  //         setFilteredData([]); // Set to an empty array if not an array
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //       setFilteredData([]); // Reset to an empty array on error
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchData();
  // }, []);

  
 

  // useEffect(() => {
  //   const result = filteredData.filter((student) => {
  //     const searchTerm = searchQuery.toLowerCase();
  //     return (
  //       (// (student.admissionNumber.toLowerCase().includes(searchTerm) ||
  //       student.surName.toLowerCase().includes(searchTerm) ||
  //       student.firstName.toLowerCase().includes(searchTerm) ||
  //       student.lastName.toLowerCase().includes(searchTerm)) &&
  //       (selectedClass ? student.class === selectedClass : true) &&
  //       (selectedSection ? student.section === selectedSection : true)
  //     );
  //   });
   
  //   setFilteredData(result);
  // }, [searchQuery]);

  // const toRoman = (num) => {
  //   const romanNumerals = [
  //     { value: 1000, symbol: "M" },
  //     { value: 900, symbol: "CM" },
  //     { value: 500, symbol: "D" },
  //     { value: 400, symbol: "CD" },
  //     { value: 100, symbol: "C" },
  //     { value: 90, symbol: "XC" },
  //     { value: 50, symbol: "L" },
  //     { value: 40, symbol: "XL" },
  //     { value: 10, symbol: "X" },
  //     { value: 9, symbol: "IX" },
  //     { value: 5, symbol: "V" },
  //     { value: 4, symbol: "IV" },
  //     { value: 1, symbol: "I" },
  //   ];
  
  //   let result = '';
  //   for (let i = 0; i < romanNumerals.length; i++) {
  //     while (num >= romanNumerals[i].value) {
  //       result += romanNumerals[i].symbol;
  //       num -= romanNumerals[i].value;
  //     }
  //   }
  //   return result;
  // };


  const handleDownload = () => {
    const csvContent = [
      [
        "S.No",
        "Admission Number",
        "Name",
        "Father Name",
        "Mother Name",
        "Mobile No",
        "Gender",
        "Class",
        "Section",
      ].join(","),
      ...filteredData.map((row, index) =>
        [
          index + 1,
          row.admissionNumber,
         `${row.firstName} ${row.lastName}`, // Combined full name
          row.fathersFirstName,
          row.mothersFirstName,
          row.primaryContact,
          row.gender,
          row.class,
          row.section,
        ].join(",")
      ),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "student_list.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

 

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
            marginTop:"60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", mb: 3, textAlign: "center" }}
          >
            Student Branch Transfer List
          </Typography>

          <Box
  display="flex"
 
  mb={3}
  flexWrap="wrap"
>
 <TextField
       label="Search by Name Or Mobile No"
       variant="outlined"
       size="small"
       value={searchQuery}
       onChange={(e) => setSearchQuery(e.target.value)}
       sx={{ marginRight: 2 }}
     />


 <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
   <InputLabel id="class-select-label">Select Class</InputLabel>
   <Select
     labelId="class-select-label"
     value={selectedClass}
     onChange={(e) => setSelectedClass(e.target.value)}
     label="Select Class"
     sx={{ height: 35 }} // Slightly reduced height
   >
     {[...Array(9).keys()].map((i) => ( // Limit to 9 classes (I - IX)
       <MenuItem key={i + 1} value={i + 1}>
         Class-{toRoman(i + 1)} {/* Convert number to Roman numeral */}
       </MenuItem>
     ))}
   </Select>
 </FormControl>
 

  <FormControl size="small" sx={{ minWidth: 120, marginRight: 35 }}>
       <InputLabel>Select Section</InputLabel>
       <Select
         value={selectedSection}
         onChange={(e) => setSelectedSection(e.target.value)}
         label="Select Class"
         sx={{ height: 35 }} // Slightly reduced height
       >
         {["A", "B", "C", "D"].map((section) => (
           <MenuItem key={section} value={`SECTION-${section}`}>
             SECTION-{section}
           </MenuItem>
         ))}
       </Select>
     </FormControl>



 <Box sx={{ flexGrow: 1 }} />
  <Button
  variant="contained"
  sx={{
    backgroundColor: "#3C3972", // Custom green color
    color: "white",
    "&:hover": {
      backgroundColor: "#3C3972", // Darker green for hover
    },
  }}
  onClick={() => navigate("/BranchTransfer")}
>
  Branch Transfer Form
</Button>

</Box>

<GlobalStyles
          styles={{
            '.custom-sidebar-scrollbar': {
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: 'grey #e0e0e0',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar': {
              width: '6px', // For WebKit-based browsers
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
              background: '#f1f1f1', // Track color
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey', // Thumb color
              borderRadius: '10px',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
          }}
        />

          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "800px",
              overflow: "auto",

            }}
             className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
  <TableHead  >
    <TableRow >
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" ,backgroundColor: "#fff9c4" ,fontWeight:'Bold' }}>S.No</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px" , textAlign: "center",backgroundColor: "#fff9c4" ,fontWeight:'Bold' }}>Pass Photo</TableCell>
      {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px" }}>Admission Number</TableCell> */}
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px",backgroundColor: "#fff9c4", textAlign: "center"  ,fontWeight:'Bold' }}>Class</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px",backgroundColor: "#fff9c4", textAlign: "center"  ,fontWeight:'Bold' }}>Section</TableCell>
      
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" , whiteSpace: "nowrap",backgroundColor: "#fff9c4", overflow: "hidden", textOverflow: "ellipsis" ,fontWeight:'Bold' }}>Name</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" , whiteSpace: "nowrap",backgroundColor: "#fff9c4", overflow: "hidden", textOverflow: "ellipsis" ,fontWeight:'Bold' }}>Father Name</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" , whiteSpace: "nowrap", backgroundColor: "#fff9c4",overflow: "hidden", textOverflow: "ellipsis",fontWeight:'Bold'  }}>Mother Name</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" ,backgroundColor: "#fff9c4",fontWeight:'Bold'  }}>Mobile No</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px",backgroundColor: "#fff9c4", textAlign: "center"  ,fontWeight:'Bold' }}>Gender</TableCell>
   
      <TableCell sx={{ padding: "4px" ,backgroundColor: "#fff9c4", textAlign: "center" ,fontWeight:'Bold' }}>Full Details</TableCell>
    </TableRow>
  </TableHead>
  {loading ? (
    <TableBody>
      <TableRow>
        {/* <TableCell colSpan={13} sx={{ textAlign: "center" }}>
          <CircularProgress size={20} />
        </TableCell> */}
         <TableCell colSpan={10} style={{ textAlign: "center", padding: "20px" }}>
                                <Box display="flex" flexDirection="column" alignItems="center">
                                  <CircularProgress />
                                  <Typography variant="body2" sx={{ mt: 1 }}>
                                    Loading Data...
                                  </Typography>
                                </Box>
                              </TableCell>
      </TableRow>
    </TableBody>
  ) : filteredData.length === 0 ? (
    <TableBody>
      <TableRow>
        <TableCell colSpan={10} sx={{ textAlign: "center" }}>
          No data found
        </TableCell>
      </TableRow>
    </TableBody>
  ) : (
   <TableBody>
  {filteredData.map((row, index) => (
    <TableRow key={row.admissionNumber} style={{
      backgroundColor: "white",
      transition: "background-color 0.3s",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = "white"; // Default color
    }}>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {index + 1}
      </TableCell>
      <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
    display: "flex",
    flexDirection: "column", // Stack items vertically
    justifyContent: "center", // Center the content vertically
    alignItems: "center", // Center the content horizontally
  }}
>
  <Avatar src={row.passPhoto} alt="Pass Photo" sx={{ width: 25, height: 25, objectFit: "cover" }} />
  {row.admissionNumber}
</TableCell>

      {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "3px", textAlign: "center" }}>
        {row.admissionNumber}
      </TableCell> */}
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
      Class-{row.romanNumberClass}
      </TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {row.sections}
      </TableCell>
       <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "center" }}>{`${row.firstName} ${row.lastName}`}</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "center" }}>
        {row.fathersFirstName} {row.fathersLastName}
      </TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "center" }}>
        {row.mothersFirstName} {row.mothersLastName}
      </TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {row.primaryContact}
      </TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {row.gender}
      </TableCell>
      
      <TableCell
sx={{ borderRight: "1px solid #ddd", padding: "4px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "center" }}
>
  <Button
    type="button"
    onClick={() =>
      navigate(`/TransferCertificate/${row.admissionNumber}`, {
        state: { student: row },
      })
    }
    sx={{
      backgroundColor: "#1976d2",
      color: "white",
      fontSize: "0.6rem", // Reduces the font size
      // padding: "5px 10px",  // Reduces the padding
      height: "25px",       // Reduces the height
      "&:hover": {
        backgroundColor: "#1565c0",
      },
    }}
  >
    View
  </Button>
</TableCell>

    </TableRow>
  ))}
</TableBody>


  )}
</Table>

          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default StudentBranchTransferList;
